import "./content.css";

import { Button, Card, Grid, Spin, Tabs } from "antd";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { actualCourseState, courseDataState } from "../../components/Atoms/Course/courseData";
import { getProfileLocal, setCoursesLocal, setProfileLocal } from "../../utils/common";

import AboutCourse from "../../components/Content/AboutCourse";
import AcademicPendencies from "../../components/Content/AcademicPendencies";
import Additional from "../../components/Content/Additional";
import AppLayout from "../../components/Layout";
import Ratings from "../../components/Content/Ratings";
import TabButton from "../../components/Content/TabButton";
import { UserContext } from "../../contexts/AuthContext";
import { api } from "../../services/api";
import { useRecoilState } from "recoil";

const { TabPane } = Tabs;
const { useBreakpoint } = Grid;

export default function Content() {
  const breakpoint = useBreakpoint();
  const [loading, setLoading] = useState(false);
  const { profile } = useContext(UserContext);
  const [course, setCourse] = useState({});

  const [currentTab, setCurrentTab] = useState("tab1");
  const [getActualCourseState, setActualCourseState] = useRecoilState(actualCourseState);

  const handleClick = (tab) => {
    setCurrentTab(tab);
  };

  let componentMounted = true;

  const getCourses = async () => {
    setLoading(true);
    await api
      .get(`/panel/student-courses/${getProfileLocal()?.enrollment_hash}`)
      .then((res) => {
        setCourse(res.data.data);
        setProfileLocal({ ...getProfileLocal(), enrollment_hash: res.data.data.enrollment_hash, actual_course: res.data.data })
        setActualCourseState(res.data.data)
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (componentMounted) {
      getCourses();
    }
    return () => {
      componentMounted = false;
    };
  }, []);

  const aboutCourse = {
    ...course
  };
  

  const tabs = [
    {
      title: "Sobre o curso",
      content: <AboutCourse aboutCourse={aboutCourse} />,
      key: "tab1",
    },
    {
      title: "Pendencias acadêmicas",
      content: <AcademicPendencies />,
      key: "tab2",
      disabled: false
    },
    {
      title: "Material complementar",
      content: <Additional />,
      key: "tab3",
    },
    {
      title: "Avaliações e nota",
      content: <Ratings />,
      key: "tab4",
      disabled: false
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ padding: breakpoint.sm ? "0 30px" : "0 5px" }}>
        <div
          className="container-content-title"
          style={{
            marginBottom: breakpoint.md ? 0 : 20,
          }}
        >
          <h3
            style={{
              fontSize: "1.75rem",
              marginTop: "0",
            }}
          >
            {course?.course_name}
          </h3>
        </div>
        {/* <Card style={{ padding: "20px", borderRadius: 3 }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-around",
            }}
          >
            {tabs.map(({ title, key, disabled }) => (
              <TabButton
                key={key}
                title={title}
                tabKey={key}
                currentTab={currentTab}
                handleClick={handleClick}
                disabled={!!disabled}
              />
            ))}
          </div>
        </Card> */}
        <div style={{ marginTop: 20 }}>
          {tabs.find(({ key }) => key === currentTab).content}
        </div>
      </div>
    </Spin>
  );
}
